var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdficon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upload File icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M-0.001,0.001 L-0.001,48.001 L22.999,48.001 C30.167,48.001 36.001,42.167 36.001,35.001 L36.001,35.001 L36.001,0.001 L-0.001,0.001 Z M2,2.001 L34,2.001 L34,35.001 C34,41.064 29.065,46 22.999,46 L22.999,46 L2,46 L2,2.001 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload-File-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 92,
    height: 92
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F1F6FD",
    cx: 46,
    cy: 46,
    r: 46
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(28.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "PDF",
    fontFamily: "SourceSansPro-SemiBold, Source Sans Pro",
    fontSize: 11,
    fontWeight: 500,
    fill: "#1352DE"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 42
  }, "PDF")), /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1540-Copy"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-1539"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1538",
    fill: "#1352DE",
    mask: "url(#mask-2)",
    points: "-5 53 41 53 41 -5 -5 -5"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1541-Copy",
    fill: "#1352DE",
    points: "9.75 12 25.5 12 25.5 9.75 9.75 9.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1542-Copy",
    fill: "#1352DE",
    points: "9.75 20.25 25.5 20.25 25.5 18 9.75 18"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1543-Copy",
    fill: "#1352DE",
    points: "9.75 28.5 21.75 28.5 21.75 26.25 9.75 26.25"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.3db73c48bde8ca9c3414d026212df69f.svg";
export { ForwardRef as ReactComponent };